// @ts-nocheck

import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userActionCreators } from '../../actions';
import { actions as loginActions } from '../../actions/login';
import { RedirectServices, getRedirectUrl } from '../../config/urls';
import useMergeProps from '../../hooks/useMergeProps';
import { __ } from '../../i18n/l10n';
import { openKLView as openKLViewAction } from '../../modules/koh-lanta/actions/routes';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';

import App from './App';
import selectAppProps from './App.selector';

type AppContainerProps = {
  className?: string;
};

const AppContainer = (ownProps: AppContainerProps) => {
  const dispatch = useDispatch();

  const licence = useSelector(selectRuntimeLicence);

  const selectedProps = useSelector(selectAppProps);
  const { isLicenceES } = selectedProps;

  const setFlagNewUser = useCallback(() => {
    dispatch(userActionCreators.setFlagNewUser());
  }, [dispatch]);

  const tryLoginEmbedded = useCallback(() => {
    dispatch(loginActions.tryLoginEmbedded(licence, 'app-start'));
  }, [dispatch, licence]);

  const triggerDeprecatedPopup = useCallback(() => {
    const id = isLicenceES ? 'es' : 'main';
    const url = getRedirectUrl(RedirectServices.APP_STORE, {
      os: 'android',
      store: 'google',
      id,
      target: 'external',
    });

    const actions = [
      {
        label: __('Update'),
        type: 'link',
        action: url,
      },
    ];

    return dispatch(
      userActionCreators.setMessages([
        { text: __('Your app is out of date, please update to the latest version'), actions, dismissable: true },
      ]),
    );
  }, [dispatch, isLicenceES]);

  const openKLView = useCallback(() => {
    dispatch(openKLViewAction());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      setFlagNewUser,
      tryLoginEmbedded,
      triggerDeprecatedPopup,
      openKLView,
    }),
    [setFlagNewUser, tryLoginEmbedded, triggerDeprecatedPopup, openKLView],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <App {...enhancedProps} />;
};

export default AppContainer;
